/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var cmp = _interopDefault(require('./ol-cmp'));
var stubVNode = _interopDefault(require('./stub-vnode'));

/**
 * Basic ol component with stub VNode, i.e. virtual component
 */
var olVirtCmp = {
  mixins: [stubVNode, cmp],
  methods: {
    /**
     * @return {Promise}
     * @protected
     */
    init: function init() {
      return cmp.methods.init.call(this);
    },

    /**
     * @return {void|Promise<void>}
     * @protected
     */
    deinit: function deinit() {
      return cmp.methods.deinit.call(this);
    },

    /**
     * @return {*}
     * @protected
     * @abstract
     */
    createOlObject: function createOlObject() {
      throw new Error('Not implemented method');
    },

    /**
     * Redefine for easy call in child components
     * @returns {Object}
     * @protected
     */
    getServices: function getServices() {
      return cmp.methods.getServices.call(this);
    },

    /**
     * Refresh internal ol objects
     * @return {Promise}
     */
    refresh: function refresh() {
      return cmp.methods.refresh.call(this);
    }
  }
};

module.exports = olVirtCmp;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/ol-virt-cmp.js
// module id = 102
// module chunks = 1